module.exports = __webpack_public_path__ + "static/media/bg43.9eb495ce.jpg";